

















































































































import { Component, Watch } from 'vue-property-decorator';
import { CampaignDetailsModule } from '@/store/modules/campaignDetails';
import CampaignBrowseOpportunitiesSearchCriteria from '@/components/CampaignOpportunities/CampaignBrowseOpportunitiesSearchCriteria.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import CampaignStatus from '@/models/Campaigns/CampaignStatus';
import CreateCampaignOpportunitiesRequest from '@/models/CampaignOpportunities/CreateCampaignOpportunitiesRequest';

@Component({
  name: 'CampaignBrowseOpportunities',
  components: { CampaignBrowseOpportunitiesSearchCriteria }
})
export default class extends GiganautVue {

	campaignStatusEnum = CampaignStatus;
	page = 1;
	perPage = 8;

	existingOpportunity(id: string) {
		return CampaignDetailsModule.campaignOpportunitiesVM.campaignOpportunities
			.some(co => co.opportunityId === id);
	}

	get isCampaignStatusDraft() {
		return CampaignDetailsModule.currentCampaign.status === CampaignStatus.Draft;
	}

	get selectedOpportunityId() {
		return CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunityId;
	}

	set selectedOpportunityId(id: string) {
		CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunityId = id;
	}

	get selectedOpportunityIds() {
		return CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunityIds;
	}

	get selectedOpportunity() {
		return CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunity;
	}

	get venueTypeName(): string {
		const o = this.selectedOpportunity;
		return o && o.prospectLocationType ? o.prospectLocationType.name : '';
	}

	get opportunities() {
		return CampaignDetailsModule.browseOpportunitiesVM.opportunities;
	}

	get pagedOpportunities() {
		return this.opportunities.slice((this.page - 1) * this.perPage, this.page * this.perPage);
	}

	@Watch('selectedOpportunityId', { immediate: true })
	async onSelectedOpportunityIdChanged(val: string) {
		if (val !== '') {
			await CampaignDetailsModule.updateSelectedBrowseOpportunity(val);
		}
	}

	async onPageChanged() {
		if (this.pagedOpportunities.length > 0) {
			CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunityId = this.pagedOpportunities[0].entity.id;
		}
	}

	get loadingOpportunities() {
		return CampaignDetailsModule.loadingOpportunities;
	}

	async updateSelectedOpportunityIds(val: boolean, opportunityId: string) {
		if (val) {
			await CampaignDetailsModule.addBrowseSelectedOpportunityId(opportunityId);
		} else {
			await CampaignDetailsModule.removeBrowseSelectedOpportunityId(opportunityId);
		}
	}

	async addOpportunitiesToAudience() {
		if (CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunityIds.length > 0) {
			const request = new CreateCampaignOpportunitiesRequest();
			request.opportunityIds = CampaignDetailsModule.browseOpportunitiesVM.selectedOpportunityIds;
			await CampaignDetailsModule.createCampaignOpportunities(request);
			await CampaignDetailsModule.getCampaignOpportunities();
		}
	}
}
